import { Box, Chip, Tooltip, Typography } from '@mui/material';
import { AddOn } from '@acorn-portal/shared/src/services/api';
import { FC } from 'react';

interface IAddons {
	addOns?: AddOn[];
}

const AddOns: FC<IAddons> = ({ addOns }) => {
	if (!addOns || addOns.length <= 0) return null;

	return (
		<Box
			sx={{
				display: 'flex',
				gap: 1,
				flexWrap: 'wrap',
				borderTop: 1,
				borderColor: 'grey.300',
				mt: 0,
				py: 2,
			}}
		>
			<Typography sx={{ fontWeight: 'bold', display: 'block', width: '100%' }}>Optional Extras</Typography>
			{addOns.map((addOn: AddOn) => (
				<Tooltip key={addOn.name} title={addOn.amount}>
					<Chip size='small' label={addOn.name} />
				</Tooltip>
			))}
		</Box>
	);
};

export default AddOns;
